import React, { useContext, useState, useEffect } from "react";
import { BrowserRouter as Router, Switch, Route, Redirect, useRouteMatch } from "react-router-dom";
import { PrivateRoutesContext } from "app/PrivateRoutesContext";

import Logout from "pages/Auth/Logout";
import Dashboard from "area/ccui/Dashboard";
import Messages from "area/ccui/Messages";
import Uploads from "area/ccui/Uploads";
import Files from "area/ccui/Files";
import Layout from "./Layout"

export default function CCUIRoutes({ portal }) {
  const { modalIsOpen,setModalIsOpen, companyId, setCompany,userInfo } = useContext(PrivateRoutesContext);

  useEffect(() => {
    let selectedCompany = localStorage.getItem(`selectedCompanyId`);
    if (selectedCompany == null || selectedCompany === "") {
      console.log("Prompting for company from CCUIRoutes")
      setModalIsOpen(true)
    }
    else{
      setCompany(selectedCompany)
    }

    document.title = "AXIM FringeSecure | Collection Company";
  }, []);

    let { path, url } = useRouteMatch();
    return (
      <Layout >
        <Switch>
          <Route exact path={`${path}/`}>
            <Redirect to={`${path}/dashboard`} />
          </Route>
          <Route exact path={`${path}/dashboard`} component={Dashboard} />
          <Route exact path={`${path}/logout`} component={Logout} />
          <Route exact path={`${path}/messages`} component={Messages} />
          <Route exact path={`${path}/uploads`} component={Uploads} />
          <Route exact path={`${path}/files`} component={Files} />
        </Switch>
      </Layout>
    )
}